(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio"] && !Shopify.designMode) return;
  try {
    
// Studio modal start
const modal = document.getElementById('studioModal');
const modalImg = document.getElementById('studioModalImg');
const modalDesc = document.getElementById('studioModalDesc');
const closeBtn = document.querySelector('.studio-modal-close');

// Function to open modal
function openModal(imgSrc, desc) {
  modalImg.src = imgSrc;
  modalDesc.textContent = desc;
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

// Function to close modal
function closeModal() {
  modal.style.display = 'none';
  document.body.style.overflow = '';
}

// Click event for map tags
document.querySelectorAll('.map-name-tag').forEach(tag => {
  tag.addEventListener('click', function() {
    const imgSrc = this.getAttribute('data-image');
    const desc = this.getAttribute('data-description');
    openModal(imgSrc, desc);
  });
});

// Click event for studio cards
document.querySelectorAll('.studio-card').forEach(card => {
  card.addEventListener('click', function() {
    const imgSrc = this.getAttribute('data-image');
    const desc = this.getAttribute('data-description');
    openModal(imgSrc, desc);
  });
});

// Close modal actions
closeBtn.addEventListener('click', closeModal);
modal.addEventListener('click', (e) => {
  if (e.target.id === 'studioModal') closeModal();
});



// Gear Modal
const gearBtn = document.getElementById('gearBtn');
const modalGear = document.getElementById('gearModal');
const closeBtnGear = document.querySelector('.custom-modal-close');

if (gearBtn && modalGear) {
  gearBtn.addEventListener('click', (e) => {
    e.preventDefault(); // prevents accidental link jumps if button is inside <a>
    modalGear.style.display = 'grid';
    document.body.style.overflow = 'hidden';
  });
}

// Close modal actions
closeBtnGear.addEventListener('click', (e) => {
    e.preventDefault(); 
    modalGear.style.display = 'none';
    document.body.style.overflow = '';
});
if (modalGear) {
  modalGear.addEventListener('click', (e) => {
    // if the click target IS the background (not the inner content)
    if (e.target === modalGear) {
      modalGear.style.display = 'none';
      document.body.style.overflow = '';
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const cards = document.querySelectorAll(".team-card");
  const body = document.querySelector("body");

  cards.forEach(card => {
    card.addEventListener("click", () => {
      const modalId = card.getAttribute("data-modal");
      const modal = document.getElementById(modalId);
      modal.style.display = "flex";
      body.style.overflow = "hidden";

      // Close button
      const closeBtn = modal.querySelector(".modal-close");
      closeBtn.addEventListener("click", () => {
        modal.style.display = "none";
        body.style.overflow = "";
      });

      // Close when clicking outside
      window.addEventListener("click", function handler(e) {
        if (e.target === modal) {
          modal.style.display = "none";
          window.removeEventListener("click", handler);
          body.style.overflow = "";
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
